


































import { Component, Vue } from 'vue-property-decorator';
import GpDocTypePassVaccine from '@/resources/enum/GpDocTypePassVaccine';
import CameraPageHeader from '@/components/CameraPageHeader.vue';
import GuideGpdocIntroduction from '@/components/GuideGpdocIntroduction.vue';
import FooterButton from '@/components/FooterButton.vue';

@Component({
  components: {
    CameraPageHeader,
    GuideGpdocIntroduction,
    FooterButton
  }
})
export default class Page extends Vue {
  private photoAspectRatio: number = -1;
  private scrollerHeight: number = 0;
  private dynamicAreaHeight: number = 0;

  private get header(): string {
    // 本来ならばstoreからヘッダ文字列を取得したいところだが、実装が大変そうなのでここに埋め込む
    //return this.$t(this.$store.state.camera.i18nKeyIntroductionTitleString) as string;
    return this.$t('passVaccine.gpDoc.introductionTitle') as string;
  }

  private get title(): string[] {
    let key: string = '';
    const gpDocType: string = this.$store.getters['camera/gpDocType'];
    if (gpDocType === GpDocTypePassVaccine.SecondRecord) {
      key = 'passVaccine.gpDoc.secondRecord.cameraIntroductionTitle';
    } else if (gpDocType === GpDocTypePassVaccine.SecondCertificate) {
      key = 'passVaccine.gpDoc.secondCertificate.cameraIntroductionTitle';
    } else if (gpDocType === GpDocTypePassVaccine.ThirdCertificate) {
      key = 'passVaccine.gpDoc.thirdCertificate.cameraIntroductionTitle';
    } else if (gpDocType === GpDocTypePassVaccine.ThirdInoculation) {
      key = 'passVaccine.gpDoc.thirdInoculation.cameraIntroductionTitle';
    }
    return (this.$t(key) as { [key: number]: string }) as string[];
  }

  private get description(): string[] {
    let key: string = '';
    const gpDocType: string = this.$store.getters['camera/gpDocType'];
    if (gpDocType === GpDocTypePassVaccine.SecondRecord) {
      key = 'passVaccine.gpDoc.secondRecord.cameraIntroductionDescription';
    } else if (gpDocType === GpDocTypePassVaccine.SecondCertificate) {
      key = 'passVaccine.gpDoc.secondCertificate.cameraIntroductionDescription';
    } else if (gpDocType === GpDocTypePassVaccine.ThirdCertificate) {
      key = 'passVaccine.gpDoc.thirdCertificate.cameraIntroductionDescription';
    } else if (gpDocType === GpDocTypePassVaccine.ThirdInoculation) {
      key = 'passVaccine.gpDoc.thirdInoculation.cameraIntroductionDescription';
    }
    return (this.$t(key) as { [key: number]: string }) as string[];
  }

  private get imageSrcset(): string[] {
    let key: string = '';
    const gpDocType: string = this.$store.getters['camera/gpDocType'];
    if (gpDocType === GpDocTypePassVaccine.SecondRecord) key = 'secondRecord';
    if (gpDocType === GpDocTypePassVaccine.SecondCertificate) key = 'secondCertificate';
    if (gpDocType === GpDocTypePassVaccine.ThirdCertificate) key = 'thirdCertificate';
    if (gpDocType === GpDocTypePassVaccine.ThirdInoculation) key = 'thirdInoculation';
    return [
      this.$t(`passVaccine.gpDoc.${key}.imageCameraIntroduction${1}`) as string,
      this.$t(`passVaccine.gpDoc.${key}.imageCameraIntroduction${2}`) as string,
      this.$t(`passVaccine.gpDoc.${key}.imageCameraIntroduction${3}`) as string,
      this.$t(`passVaccine.gpDoc.${key}.imageCameraIntroduction${4}`) as string
    ];
  }

  public get photoHeight(): number {
    if (this.photoAspectRatio < 0) return 0;
    const displayWidth: number = this.$store.state.camera.displayWidth;
    const displayHeight: number = this.$store.state.camera.displayHeight;
    if (displayWidth <= 0 || displayHeight <= 0) return 0;
    // 画面高さから取りうる画像高さ
    const pageHeaderHeight: number = this.$store.state.camera.headerHeight;
    const totalHeight: number = pageHeaderHeight + this.dynamicAreaHeight;
    const maxPhotoHeight: number = displayHeight - totalHeight;
    // 画面幅から計算する画像高さ
    const photoMarginHorizontal: number = this.photoAspectRatio > 1 ? 20 : 70;
    const basePhotoWidth: number = Math.min(displayWidth - photoMarginHorizontal * 2, 500);
    const basePhotoHeight: number = basePhotoWidth / this.photoAspectRatio;
    // 画像高さを計算する
    const photoHeight: number = Math.min(basePhotoHeight, maxPhotoHeight);
    const minPhotoHeight: number = 100;
    return Math.max(photoHeight, minPhotoHeight);
  }

  private get isScroll(): boolean {
    return this.scrollerHeight > this.$store.state.camera.displayHeight;
  }

  public async mounted(): Promise<void> {
    // トリムされた写真を表示してアスペクト比を取得
    this.photoAspectRatio = await new Promise((resolve: (aspect: number) => void): void => {
      const photo: HTMLImageElement = this.$el.getElementsByTagName('img').item(0) as HTMLImageElement;
      photo.addEventListener('load', () => resolve(photo.naturalWidth / photo.naturalHeight));
      photo.src = this.imageSrcset[0];
      photo.srcset = this.imageSrcset
        .map((src: string, index: number): string => src && `${src} ${index + 1}x`)
        .filter((src: string): boolean => !!src)
        .join(',');
    });

    this.calcDynamicAreaHeight();
  }

  public updated(): void {
    this.calcDynamicAreaHeight();
  }

  private calcDynamicAreaHeight(): void {
    if (!this.$el) return;
    const scroller: HTMLDivElement = this.$el.getElementsByClassName('page-scroller').item(0) as HTMLDivElement;
    const contentHeader: HTMLDivElement = this.$el.getElementsByClassName('page-contents-title').item(0) as HTMLDivElement; // eslint-disable-line prettier/prettier
    const contentFooter: HTMLDivElement = this.$el.getElementsByClassName('page-contents-description').item(0) as HTMLDivElement; // eslint-disable-line prettier/prettier
    const pageFooter: HTMLDivElement = this.$el.getElementsByClassName('page-footer').item(0) as HTMLDivElement;
    const scrollerRect: DOMRect = scroller.getBoundingClientRect() as DOMRect;
    const contentHeaderRect: DOMRect = contentHeader.getBoundingClientRect() as DOMRect;
    const contentFooterRect: DOMRect = contentFooter.getBoundingClientRect() as DOMRect;
    const pageFooterRect: DOMRect = pageFooter.getBoundingClientRect() as DOMRect;
    this.scrollerHeight = scrollerRect.height;
    this.dynamicAreaHeight = contentHeaderRect.height + contentFooterRect.height + pageFooterRect.height;
  }
}
